import React from "react"
import Back from "../common/back/Back"
import BlogCard from "./BlogCard"
import "./blog.css"

const Blog = () => {
  return (
    <div>
      <Back title='Blog Posts' />
      <section className='blog padding'>
        <div >
          <BlogCard />
        </div>
      </section>
    </div>
  )
}

export default Blog
